// 转化页面为PDF格式(文件)

import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default (refs, fn) => {
    let cloneN;
    if (Array.isArray(refs)) {
        cloneN = refs[0].cloneNode(true);
    } else {
        cloneN = refs.cloneNode(true);
    }
    const body = document.getElementsByTagName('body')[0];
    cloneN.style.position = 'absolute';
    cloneN.style.zIndex = '99999999999999999999';
    cloneN.style.top = 0;
    cloneN.style.left = 0;
    cloneN.style.width = '100%';
    cloneN.style.minHeight = '100%';
    cloneN.style.background = '#fff';
    if (refs[1]) {
        let psfBox = cloneN.getElementsByClassName(refs[1])[0];
        let printPos = cloneN.getElementsByClassName('print')[0];
        psfBox.style.width = "80%";
        // printPos.style.display = 'block'
    }
    body.appendChild(cloneN);

    html2Canvas(cloneN, {
        allowTaint: true
    }).then(function (canvas) {
            let contentWidth = canvas.width;
            let contentHeight = canvas.height;
            let pageHeight = contentWidth / 592.28 * 841.89;
            let leftHeight = contentHeight;
            let position = 0;
            let imgWidth = 595.28;
            let imgHeight = 592.28 / contentWidth * contentHeight;
            let pageData = canvas.toDataURL('image/jpeg', 1.0);
            let PDF = new JsPDF('', 'pt', 'a4');
            let pdfFile = new JsPDF();
            if (leftHeight < pageHeight) {
                PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
            } else {
                while (leftHeight > 0) {
                    PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
                    leftHeight -= pageHeight;
                    position -= 841.89;
                    if (leftHeight > 0) {
                        PDF.addPage()
                    }
                }
            }

            // 转换字符为pdf文件
            // @param str
            // @returns {File}

            // 转出为base64
            let str = PDF.output();
            let ab = new ArrayBuffer(str.length);
            let ia = new Uint8Array(ab);
            for (let i = 0; i < str.length; i++) {
                ia[i] = str.charCodeAt(i);
            }
            let file = new File([ia], "up.png", {type: "application/pdf"});

            // 返回PDF数据
            // fn(PDF);
            // 直接保存pdf
            // PDF.save('pdf.pdf');

            // 返回pdf文件
            fn(file,PDF);

            // 移除元素
            body.removeChild(cloneN);
        }
    )
};



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/htmlToPdf.js